import React from 'react';

interface BasicSwitcherProps {
    onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
    labels?: string[];
    activeIndex: number;

    className?: string;
    extraClassName?: string;
    labelClassName?: string;
    activeLabelClassName?: string;
    markerClassName?: string;
    markerStyle?: React.CSSProperties;
    style?: React.CSSProperties;
    id?: string;
}

const BasicSwitcher: React.FC<BasicSwitcherProps> = ({
                                               onClick,
                                               labels,
                                               activeIndex,
                                               className = '',
                                               extraClassName = '',
                                               labelClassName = '',
                                               activeLabelClassName = '',
                                               markerClassName = '',
                                               markerStyle,
                                               style,
                                               id,
                                           }) => {
    return (
        <div
            className={`${className} ${extraClassName}`}
            onClick={onClick}
            style={style}
            id={id}
        >
            <div className={`${markerClassName}`} style={markerStyle} />
            {labels?.map((label, index) => (
                <div
                    key={index}
                    className={`${labelClassName} ${
                        index === activeIndex ? activeLabelClassName : ''
                    }`}
                >
                    {label}
                </div>
            ))}
        </div>
    );
};

export default BasicSwitcher;
